import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_staff/payroll/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: '/payroll/overview' });
  },
});
